import React from 'react'

import {
    _getOpenEnquiries,
    _postCloseEnquiry
    
} from '../../services'

import moment from 'moment'

import { EEZEE_URL } from '../../index.js'

import './index.css'

import {
    message,
    Row,
    Col,
    Card,
    Collapse,
    Button,
    Spin,
    Table
} from 'antd'

import EnquiryModal from './modal';
import ChangeSupplierDrawer from '../orders-v2/change-supplier-drawer';

const { Panel } = Collapse

class EnquiryManager extends React.Component {
    
    render(){

        const columns = [
            {
                title:'Product',
                dataIndex: 'product',
                width: "25%",
                render: (product)=>(
                    <a  
                    target="_blank"
                    href={`${EEZEE_URL}/product/${product.uniqTitle}-${product.sku}`}>
                    {product.title}
                    </a>
                )
            },
            {
                title:'Qty',
                dataIndex:'quantity'
            },
            {
                title:'Supplier',
                render: (record) => (
                    record.supplier?
                    <div>
                        {record.supplier.details.companyName}
                    </div>
                    :
                    <a
                        onClick={()=>this.handleAssignSupplier(record)}
                    >
                        Assign
                    </a>
                )
            },
            {
                title:'Enquiry',
                dataIndex:'moreInfo',
                width:"25%"
            },
            {
                title:'Enquirer',
                render: (record) => (
                    <div>
                        <Row>
                            {record.name}
                        </Row>
                        <Row>
                            {record.companyName}
                        </Row>
                    </div>
                )
            },
            {
                title:"Contact",
               render: (record) => (
                <div>
                    <Row>
                        {record.hp}
                    </Row>
                    <Row>
                        {record.email}
                    </Row>
                </div>
               )
            }
        ]

        const { enquiriesBySession, enquiryModalVisible, productOrders, enquirer, dateEnquired } = this.state

        return(
            this.state.loading?
            this.renderLoader()
            :
            <Card
                bodyStyle={{paddingBottom: 64}}
                title={this.renderTitle()}
            >
            <ChangeSupplierDrawer
                closeDrawer={()=>this.setState({changeSupplierDrawerVisible:false})}
                visible={this.state.changeSupplierDrawerVisible}
                forProduct={true}
                productId={this.state.changeSupplierProductId}
                enquiryId={this.state.changeSupplierEnquiryId}
                getOpenEnquiries={this.getOpenEnquiries}
            />
            {enquiryModalVisible?
            <EnquiryModal
                enquirer={enquirer}
                productOrders={productOrders}
                dateEnquired={dateEnquired}

                closeModal={this.closeModal}
                handleQuantityChange={this.handleQuantityChange}
                handleVariantChange={this.handleVariantChange}
                setProductOrders={this.setProductOrders}
                setConverted={this.setConverted}
                getOpenEnquiries={this.getOpenEnquiries}
                recursiveCloseEnquiries={this.recursiveCloseEnquiries}
            />
            :
            null
            }
            {Object.keys(enquiriesBySession).map( _sessionId => {

                const enquiries = enquiriesBySession[_sessionId] //array of enquiries belonging to one session
                
                const { companyName } = enquiries[0]
                
                const earliestEnquiry = this.getEarliestEnquiry(enquiries)

                return(
                    <Collapse 
                    style={{marginBottom: 12}}>
                        <Panel
                            header={
                            <Row type="flex" justify="space-between">
                                <Col>
                                Enquiry from {companyName}
                                </Col>
                                <Col>
                                {earliestEnquiry}
                                </Col>
                            </Row>}
                        >
                        <Table
                            className="enquiry-table"
                            pagination={false}
                            dataSource={enquiries}
                            columns={columns}
                            size="small"
                            bordered
                            footer={()=>
                                <Row type="flex" justify="end" gutter={8}>
                                    <Col>
                                    <Button
                                        onClick={()=>this.handleCloseAllEnquiries(enquiries)}
                                        // size="small"
                                        type="danger"
                                    >Close all</Button>
                                    </Col>
                                    <Col>
                                    <Button
                                        onClick={()=>this.handleConvertToHoldingList(enquiries)}
                                        // size="small"
                                        type="primary"
                                    >Convert</Button>
                                    </Col>
                                </Row>
                            }
                        />
                        </Panel>
                    </Collapse>
                )

            })}
            </Card>
        )
    }

    constructor(props){
        super(props)

        this.state = {
            enquiriesBySession:false,
            enquiryModalVisible: false,
            productOrders: false,
            loading: true,
            converted: false,

            changeSupplierDrawerVisible: false,
            changeSupplierProductId: false,
            changeSupplierEnquiryId: false

        }

        this.getOpenEnquiries()
    }

    closeModal = () =>{
        this.setState({enquiryModalVisible: false})
    }

    getEarliestEnquiry = (enquiries) =>{

        let earliestEnquiry = moment(enquiries[0].dateEnquired)

        enquiries.map( _enquiry => {

            if( moment(_enquiry.dateEnquired).isBefore(earliestEnquiry)){
                earliestEnquiry = _enquiry.dateEnquired
            }

            return _enquiry;

        })

        return moment(earliestEnquiry).format("LLLL")

    }

    getOpenEnquiries = () =>{
        _getOpenEnquiries()
        .then( res => {

            console.log(res)

            let enquiriesBySession = {}

            const { enquiries } = res.data

            enquiries.map( _enquiry => {

                const { sessionId } = _enquiry

                if (enquiriesBySession[sessionId]){
                    enquiriesBySession[sessionId].push( _enquiry)
                } else {
                    enquiriesBySession[sessionId] = []
                    enquiriesBySession[sessionId].push( _enquiry )
                }

                return _enquiry;

            })

            this.setState({ enquiriesBySession, loading: false }, ()=> console.log(this.state))


        })
        .catch( err => {
            console.log(err)
            message.error("Error!")
        })
    }

    handleAction = (action, enquiry) =>{
        
        switch(action){
            case 'sendToSupplier':
                message.success("Sent check stock!")
                break;
            
            case 'sendToCustomer':
                message.success("Sent follow up!")
                break;

            case 'changeSupplier':
                this.setState({
                    changeSupplierProductId: enquiry.product._id,
                    changeSupplierDrawerVisible: true,
                    changeSupplierEnquiryId: enquiry._id
                })
                break;

            default:
                break;
        }
        
    }

    handleCloseAllEnquiries = (enquiries) => {
        
        const enquiryIds = enquiries.map( _enquiry => _enquiry._id)
        this.recursiveCloseEnquiries(enquiryIds, 0)
            
    }

    assignPriceToVariants = (availableVariants, selectedVariants) =>{
 
        let _selectedVariants = selectedVariants.map( _selectedVariant => {

            let availableVariant = availableVariants.filter( _availableVariant => _availableVariant.name === _selectedVariant.name)[0]

            let variantPrice = availableVariant._set.filter( __set => __set.name === _selectedVariant._set)[0].price
            
            _selectedVariant.price = variantPrice

            return _selectedVariant
        })

        return _selectedVariants

    }

    handleAssignSupplier = (enquiry) =>{

        this.setState({
            changeSupplierProductId: enquiry.product._id,
            changeSupplierDrawerVisible: true,
            changeSupplierEnquiryId: enquiry._id
        })

    }
    
    handleConvertToHoldingList = (enquiries) =>{
        
        let productOrders = enquiries.map( _enquiry => {
            
            const { product, variants, quantity, _id } = _enquiry
            
            let _variants = this.assignPriceToVariants(product.variants, variants)

            return({
                enquiryId: _id,
                product,
                variants: _variants,
                quantity
            })

        })

        
        this.setState({
            enquirer:enquiries[0].companyName,
            dateEnquired:enquiries[0].dateEnquired,
            enquiryModalVisible: true,
            productOrders
        }, ()=> console.log(productOrders))
    
    }

    handleQuantityChange = (quantity, enquiryId) =>{

        let productOrders = this.state.productOrders.map( _productOrder => {

            if( enquiryId === _productOrder._id){
                _productOrder.quantity = quantity
            }

            return _productOrder

        })

        this.setState({productOrders})
        
    }

    handleVariantChange = ({name, set, enquiryId}) =>{


        let productOrders = this.state.productOrders.map( _productOrder => {

            if( enquiryId === _productOrder._id ){


                let _set =  _productOrder.product.variants.filter( _variant => _variant.name === name)[0]._set

                let price = _set.filter( _set => _set.name === set)[0].price

      
                _productOrder.variants.map( _variant =>{

                    if( _variant.name === name){
                        _variant._set = set
                        _variant.price = price
                    }

                    return _variant

                })
            }

            return _productOrder
        })

        this.setState({productOrders}, ()=>console.log(this.state.productOrders))

    }

    recursiveCloseEnquiries = (enquiryIds, i) =>{

        _postCloseEnquiry(enquiryIds[i])

        if(i === enquiryIds.length-1){
            message.success("Closed all enquiries!")
            this.getOpenEnquiries()
            return;
        } else {
            this.recursiveCloseEnquiries(enquiryIds, i+1)
        }

    }

    renderAction = ({text, action, enquiry}) => {

        return(
            <a onClick={()=>this.handleAction(action, enquiry)}>
                <span style={{fontSize: 12}}>{text}</span>
            </a>
        )
        
    }

    renderLoader = () =>{
        return (
            <Row style={{height:"80vh"}} type="flex" justify="center" align="middle">
                <Col>
                    <Row style={{marginBottom: 8}} type="flex" justify="center">Assigning enquiries to sessions...</Row>
                    <Row type="flex" justify="center"><Spin/></Row>
                </Col>
            </Row>
        )
    }

    renderTitle = () =>{
        return (
            <Row type="flex" align="middle" justify="space-between">
                <Col span={12}>
                    Enquiry Manager
                </Col>
            </Row>
        )
    }

    setProductOrders = (productOrders) =>{
        this.setState({productOrders})
    }
    
}

export default EnquiryManager;


// WEBPACK FOOTER //
// ./src/components/enquiry/index.js